export default "__VITE_ASSET__17d9d0c5__"